import localScaleManager from "../../../../helpers/LocalScaleManager";

export class Avatar extends Phaser.GameObjects.Image {
  constructor(scene, isMyTable, seat, table) {
    super(scene, 0, 0, "avatars", "05");
    this.scene = scene;
    this.seat = seat;
    this.table = table;
    this.isMyTable = isMyTable;
    this.scene.add.existing(this);
    this.table.poolArray.push(this);

    this.atlasName = "avatars";
    // this.bg = this.scene.add.image(0, 0, this.scene.atlasTexture, "avatar-bg"); // this.bg = new Button(this.scene, 'avatar-bg', true);
    // this.table.poolArray.push(this.bg);
    this.isClicked = false;
    this.setInteractive({ cursor: "pointer" });
    this.on("pointerdown", this.onPointerDown, this);
    this.on("pointerup", this.hideHand, this);
    // this.bg.on('pointerout',this.onBgPointerOut, this);
    // this.bgHitArea = {};
    // this.bgHitArea = new Phaser.Geom.Rectangle(0, 0, 0, 0);
    // this.table.poolArray.push(this.bgHitArea);
    // this.setDepth(this.bg.depth + 1);
    this.boxWidth = 0;
    this.boxHeight = 0;
    this.boxInitX = 0;
    this.boxInitY = 0;
    this.overlay = this.table.overlay;
    // this.overlay = this.scene.add.rectangle(0, 0, 0, 0, 0x000000);
    // this.table.poolArray.push(this.overlay);
    // this.overlay.setAlpha(0);
    // this.overlay.setDepth(90);
  }
  visibilityControls(visibility) {
    if (this.visible !== visibility) this.setVisible(visibility);
    // if (this.bg.visible !== visibility) this.bg.setVisible(visibility);
  }
  updateAvatar(avatar, isMyTable, setInteractiveAvatar) {
    const texture =
      avatar && avatar.split(".png")[0] ? avatar.split(".png")[0] : "05";
    this.visibilityControls(true);
    this.isMyTable = isMyTable;
    if (this.frame.name !== texture) {
      this.setFrame(texture, false, false);
      // this.positionControls(
      //   this.boxWidth,
      //   this.boxHeight,
      //   this.boxInitX,
      //   this.boxInitY
      // );
    }
    // if (!isMyTable) return;
    if (setInteractiveAvatar) {
      this.setInteractive({ cursor: "pointer" });
    } else {
      this.disableInteractive();
      // this.bgIsClicked = false;
      // this.hideOverlay();
      this.hideHand();
    }
    if(!this.seat.playerInfo.online || this.seat.playerInfo.state === "SitOut" || this.seat.playerInfo.afk){
      if(this.alpha != .2) this.setAlpha(.2)
    }
    else {
      if(this.alpha != 1) this.setAlpha(1)
    }
  }
  setDisable(status) {
    // if (status) {
    //   this.bg.setDepth(10);
    // } else {
    //   this.bg.setDepth(0);
    // }
  }
  onPointerDown() {
    if (!this.isClicked) {
      this.seat.cards.showHandOnFold();
      this.isClicked = true;
      this.showOverlay();
    }
  }
  hideHand() {
    if (this.isClicked) {
      this.seat.cards.hideHandOnFold();
      this.isClicked = false;
      this.hideOverlay();
    }
  }
  showOverlay() {
    if (!this.overlay.visible) {
      this.table.offOverlayEvents();
      this.overlay.on("pointerup", this.hideHand, this);
      this.overlay.on("pointerout", this.hideHand, this);
      this.overlay.setVisible(true);
    }
  }
  hideOverlay() {
    if (this.overlay.visible) {
      this.table.offOverlayEvents();
      this.overlay.setVisible(false);
    }
  }
  /***
   *
   * @param width {number} width of seat box
   * @param height {number} width of seat box
   * @param initX {number} seat box top left x
   * @param initY {number} seat box top left y
   */
  positionControls(width, height, initX, initY) {
    this.boxWidth = width;
    this.boxHeight = height;
    this.boxInitX = initX;
    this.boxInitY = initY;
    // const bgSize = this.isMyTable ? width / 1.4 : width / 1.2;
    // const bgSize = this.isMyTable ? width / 1.8 : width / 1.6;
    // localScaleManager.scaleSprite(this.bg, bgSize, bgSize, 0, 1, true);
    // localScaleManager.scaleSpriteTo(this.bg, bgScale);
    // this.bg.setPosition(
    //   initX,
    //   this.isMyTable ? initY - height / 4 : initY - height / 3.5
    // );

    // const avatarSize = this.isMyTable ? width / 1.8 : width / 1.6;
    const avatarSize = this.isMyTable ? width * 0.8 : width;
    // const avatarSize = width;

    localScaleManager.scaleSprite(this, avatarSize, avatarSize, 0, 1, true);
    // localScaleManager.scaleSpriteTo(this, bgScale);
    // this.setPosition(initX, this.isMyTable ? initY - height / 4 : initY - height / 3.5);
    // this.setPosition(
    //   initX,
    //   this.isMyTable ? initY - height / 4 : initY - height / 3.5
    // );
    this.setPosition(
      initX,
      initY -
        (this.isMyTable ? this.displayHeight * 0.6 : this.displayHeight * 0.5)
    );
    // this.bgHitArea = new Phaser.Geom.Rectangle(
    //   -this.bg.displayWidth * 0.5,
    //   0,
    //   this.bg.displayWidth * 2,
    //   this.bg.displayHeight * 2.5
    // );
    // this.table.poolArray.push(this.bgHitArea);

    // this.bgHitArea.setPosition(-this.bg.displayWidth * 0.5, 0);
    // this.bgHitArea.setSize(this.bg.displayWidth * 2, this.bg.displayHeight * 2.5);

    // let graphics2 = this.scene.add.graphics();
    //     graphics2.lineStyle(2, 0xffff00);
    //     graphics2.strokeRect(this.bg.x - this.bg.displayWidth / 2 + this.bgHitArea.x, this.bg.y - this.bg.displayHeight / 2 + this.bgHitArea.y,this.bgHitArea.width,this.bgHitArea.height);

    // this.bg.setInteractive(this.bgHitArea, Phaser.Geom.Rectangle.Contains);
    // this.bg.setInteractive({ cursor: "pointer" });

    // this.overlay.width = this.scene.gameWidth;
    // this.overlay.height = this.scene.gameHeight;
    // this.overlay
    //   .setPosition(this.scene.gameWidth * (this.seat.table.tableNumber - 1), 0)
    //   .setOrigin(0);
    // this.overlay.setInteractive(
    //   new Phaser.Geom.Rectangle(
    //     0,
    //     0,
    //     this.overlay.displayWidth,
    //     this.overlay.displayHeight
    //   ),
    //   Phaser.Geom.Rectangle.Contains
    // );
    // this.overlay.on("pointerup", this.hideHand, this);
    // this.overlay.on("pointerout", this.hideHand, this);
  }
  /***
   *
   * @param width {number} width of seat box
   * @param height {number} width of seat box
   * @param initX {number} seat box top left x
   * @param initY {number} seat box top left y
   */
  reposition(width, height, initX, initY) {
    this.boxWidth = width;
    this.boxHeight = height;
    this.boxInitX = initX;
    this.boxInitY = initY;
    this.setPosition(
      initX,
      initY -
        (this.isMyTable ? this.displayHeight * 0.6 : this.displayHeight * 0.5)
    );
    // this.setPosition(
    //   initX,
    //   this.bg.y + (this.displayHeight - this.bg.displayHeight) / 2
    // );
  }
  remove() {
    // this.bg.destroy();
    this.destroy();
  }
}
